import React from 'react';
import { ListFieldSection } from '../../../Layout';
import { Field, TextOutput } from '../../../Core';

const ResultsSection = () => (
  <ListFieldSection>
    <Field label="Specific Gravity (Oven Dry)" input={<TextOutput />} name="Results.SpecificGravityOvenDry" />
    <Field label="Specific Gravity (SSD)" input={<TextOutput />} name="Results.SpecificGravitySSD" />
    <Field label="Apparent Specific Gravity" input={<TextOutput />} name="Results.ApparentSpecificGravity" />
    <Field label="Absorption (%)" input={<TextOutput />} name="Results.Absorption" />
  </ListFieldSection>
);

export { ResultsSection };
export default ResultsSection;
